import { render } from "./register.vue?vue&type=template&id=5388dde0&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=5388dde0&lang=less&scoped=true"
import "./register.vue?vue&type=style&index=1&id=5388dde0&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5388dde0"]])

export default __exports__